import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuditLogApp } from '../auditlog-ui/auditlog.component';

const routes: Routes = [
{ 
    path: 'auditlogapp', component: AuditLogApp},
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// ./src/auditlog/src/auditlog-ui/auditlog.routes.ts